import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IAbstractRecord } from '@models';
import { REGEX, isEmpty } from '@utils/validationUtils';

export const initialValues = {
  type: '',
  companyName: '',
  title: '',
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',
  email: '',
  phoneType: '',
  phoneNumber: '',
};

export const inputs: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      type: {
        name: 'type',
        title: 'Type',
        type: FormFieldType.select,
        placeholder: 'Type',
        value: !isEmpty(initialValues.type) ? [initialValues.type] : [],
        selectOptions: {},
        disabled: false,
        required: true,
      },
      companyName: {
        name: 'companyName',
        title: 'Company Name',
        placeholder: 'Company Name',
        type: FormFieldType.text,
        value: initialValues.companyName,
        required: false,
        disabled: false,
        hidden: false,
        minCharacters: 2,
        maxCharacters: 100,
        conditionalRequired: (values: Record<string, any>) => {
          const isCompany = values?.type?.toLowerCase() === 'company';
          return isCompany;
        },
        conditionalDisable: (values: Record<string, any>) => {
          const isCompany = values?.type?.toLowerCase() === 'company';
          return !isCompany;
        },
        conditionalHidden: (values: Record<string, any>) => {
          const isCompany = values?.type?.toLowerCase() === 'company';
          return !isCompany;
        },
      },
      title: {
        name: 'title',
        title: 'Title',
        placeholder: 'Title',
        type: FormFieldType.select,
        value: !isEmpty(initialValues.title) ? [initialValues.title] : [],
        hidden: false,
        required: false,
        disabled: false,
        selectOptions: {},
        conditionalRequired: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return isPerson;
        },
        conditionalDisable: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
        conditionalHidden: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
      },
      firstName: {
        name: 'firstName',
        title: 'First Name',
        placeholder: 'First Name',
        type: FormFieldType.text,
        value: initialValues.firstName,
        hidden: false,
        required: false,
        disabled: false,
        minCharacters: 2,
        maxCharacters: 100,
        conditionalRequired: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return isPerson;
        },
        conditionalDisable: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
        conditionalHidden: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
      },
      middleName: {
        name: 'middleName',
        title: 'Middle Name',
        placeholder: 'Middle Name',
        type: FormFieldType.text,
        value: initialValues.middleName,
        hidden: false,
        required: false,
        disabled: false,
        minCharacters: 1,
        maxCharacters: 100,
        conditionalRequired: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return isPerson;
        },
        conditionalDisable: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
        conditionalHidden: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
      },
      lastName: {
        name: 'lastName',
        title: 'Last Name',
        placeholder: 'Last Name',
        type: FormFieldType.text,
        value: initialValues.lastName,
        hidden: false,
        required: false,
        disabled: false,
        minCharacters: 2,
        maxCharacters: 100,
        conditionalRequired: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return isPerson;
        },
        conditionalDisable: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
        conditionalHidden: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
      },
      dateOfBirth: {
        name: 'dateOfBirth',
        title: 'Date of Birth',
        placeholder: 'Date of Birth',
        type: FormFieldType.date,
        value: initialValues.dateOfBirth,
        hidden: false,
        required: false,
        disabled: false,
        conditionalDisable: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
        conditionalHidden: (values: Record<string, any>) => {
          const isPerson = values?.type?.toLowerCase() === 'person';
          return !isPerson;
        },
      },
      email: {
        name: 'email',
        title: 'Email',
        type: FormFieldType.text,
        placeholder: 'Email',
        value: !isEmpty(initialValues.email) ? initialValues.email : null,
        required: false,
        customValidator: (values: IAbstractRecord) => {
          if (values.email && !REGEX.email.test(values.email)) {
            return 'Invalid email address';
          }
          return '';
        },
      },
      phoneType: {
        name: 'phoneType',
        title: 'Phone Type',
        type: FormFieldType.select,
        placeholder: 'Phone Type',
        value: !isEmpty(initialValues.phoneType) ? initialValues.phoneType : [],
        required: false,
        selectOptions: {},
      },
      phoneNumber: {
        name: 'phoneNumber',
        title: 'Phone Number',
        type: FormFieldType.phoneNumber,
        placeholder: 'Phone Number',
        value: initialValues.phoneNumber,
        required: false,
        editCountryCode: false,
      },
    },
  },
];
